export default __webpack_public_path__ + "static/media/guest_03_2_renato_braga_sacco.9f9fbbc2.png";